import React from 'react'

const Resources = () => {


  return (
    <body className="api-link">
      <div>
      API Link: 
        <a href='https://the-one-api.dev/'>
          { } https://the-one-api.dev/
        </a>
      </div>
    </body>
  )
}

export default Resources